module.exports = __webpack_public_path__ + "img/outterEngraving.bd4a420.jpg";